module.exports = __webpack_public_path__ + "img/3.ee3be0f2.jpg";